var React = require('react');

function CircleMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M496.001 992C769.934 992 992 769.933 992 496C992 222.067 769.934 0 496.001 0C222.068 0 0 222.067 0 496C0 769.933 222.068 992 496.001 992Z","fill":"url(#paint0_linear_5103_1213)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_5103_1213","x1":"496.586","y1":"-187.66","x2":"496.586","y2":"1218.92","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#33D5B5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#85DE5E","key":1})]))]);
}

CircleMobile.defaultProps = {"width":"1400","height":"1400","viewBox":"0 0 992 992","fill":"none"};

module.exports = CircleMobile;

CircleMobile.default = CircleMobile;
